export default {
    methods: {
        buildComparePageParamsList(list) {
            return list.map((v) => ({
                make: v.make || v.makeUrlCode,
                model: v.model || v.submodelCommercialUrlCode,
                // Right now we create the same parameter with different property names as required by API
                versionHistoricalId: v.vehicleHistoricalId || v.versionHistoricalId || v.versionId || v.version,
                vehicleHistoricalId: v.vehicleHistoricalId || v.versionHistoricalId || v.versionId || v.version,
            }));
        },
    },
};
